import dayjs from 'dayjs';
import dateFunctions from 'library/helpers/dateFunctions';
import { useCallback, useEffect, useState } from 'react';

const useCleaningChecker = ({ cleaningConfig, cleaningStartDate, cleaningEndDate }) => {
	const [isCleaning, setIsCleaning] = useState(false);

	const checkCleaning = useCallback(() => {
		const now = dayjs();

		if (cleaningConfig?.start && cleaningConfig?.end) {
			const startDate = dateFunctions.calculateDate(cleaningConfig.start);
			const endDate = dateFunctions.calculateDate(cleaningConfig.end);
			setIsCleaning(now.isBetween(startDate, endDate));
		} else if (cleaningStartDate && cleaningEndDate) {
			const startDate = dateFunctions[cleaningStartDate]();
			const endDate = dateFunctions[cleaningEndDate]();
			setIsCleaning(now.isBetween(startDate, endDate));
		}
	}, [cleaningConfig, cleaningStartDate, cleaningEndDate]);

	useEffect(() => {
		// run once immediately
		checkCleaning();

		// then every 60 seconds
		const intervalId = setInterval(checkCleaning, 60000); // 60 seconds
		return () => clearInterval(intervalId);
	}, [checkCleaning]);

	return isCleaning;
};

export default useCleaningChecker;
